export interface BirthType {
  id: string
  value: string
}

interface BirthTypeProps {
  [key: string]: BirthType
}

export const birthTypes: BirthTypeProps = {
  normal: {
    id: 'normal',
    value: 'Normal'
  },
  cesariana: {
    id: 'cesariana',
    value: 'Cesariana'
  },
  distocico: {
    id: 'distocico',
    value: 'Distócico'
  },
  gemelar: {
    id: 'gemelar',
    value: 'Gemelar'
  }
}

export const birthTypeOptions = Object.keys(birthTypes).map((key: string) => birthTypes[key])
